
import axios from 'axios'
import env from "./config/env"
//expose axios to global object
window.axios = axios;

window.axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('token')

window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');


window.Echo = new Echo({
    broadcaster: 'pusher',
    key: 'sasasa',
    cluster: 'sasasa',
    wsHost: env.webserviceHost,
    authEndpoint: env.normalURL + 'broadcasting/auth',
    auth: {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
    },
    wsPort: env.webservicePort,
    forceTLS: false,
    disableStats: true,
});


// Monitora todos os estados da conexão
window.Echo.connector.pusher.connection.bind("unavailable", () => {
    console.error("❌ WebSocket: Servidor indisponível");
});

window.Echo.connector.pusher.connection.bind("failed", () => {
    console.error("❌ WebSocket: Falha na conexão");
});

window.Echo.connector.pusher.connection.bind("disconnected", () => {
    console.warn("⚠️ WebSocket: Desconectado");
});

window.Echo.connector.pusher.connection.bind("error", (error) => {
    console.error("❌ WebSocket: Erro de conexão", error);
});

window.$ = window.jQuery = require('jquery');
require('bootstrap');
